export const MY_SHOP_STAGING_HOST = 'my-shop.staging.fourthwall.com'
export const MY_SHOP_PRODUCTION_HOST = 'my-shop.fourthwall.com'

export const MY_SHOP_STAGING_URL = `https://${MY_SHOP_STAGING_HOST}/admin/dashboard?redirect`
export const MY_SHOP_PRODUCTION_URL = `https://${MY_SHOP_PRODUCTION_HOST}/admin/dashboard?redirect`
